<template>
  <div
    id="app"
    :class="{
      'overflow-auto': $route.meta.addPageScroll,
      'dark-bcg': $route.meta.darkBcg,
      'pl-0': $route.meta.hideNavigation === true,
      'progress-nav-closed': getNavClosed,
    }"
  >
    <div
      class="side-nav"
      :class="{ open: openSideNav }"
      @mouseleave="(openSideNav = false), (sidePanel = false)"
      v-if="$route.meta.hideNavigation !== true"
    >
      <div class="side-nav__logo-wrapper" @click="goHome">
        <div class="side-nav__logo"></div>
        <div
          class="logoSection__text side-nav__logo-text"
          v-if="account.SkinIdentifier === 'pg'"
        >
          Superiority 365 <span>Testing platform</span>
        </div>
      </div>
      <div
        class="side-nav__close"
        @click="(openSideNav = false), (sidePanel = false)"
      ></div>
      <ul class="side-nav__list" v-if="showTopBarNav">
        <li
          id="headerProjectsLink"
          :class="{ 'is-active': $route.name === 'home' }"
          @mouseover="openSideNav = true"
        >
          <router-link to="/" @click.native="openSideNav = false"
            ><i>
              <icon-base
                :width="40"
                :height="40"
                :viewBox1="48"
                :viewBox2="48"
                iconName="home"
                ><icon-home /></icon-base></i
            ><span>Home</span></router-link
          >
        </li>
        <li
          id="headerDashboardLink"
          :class="{
            'is-active':
              $route.name === 'all-projects' ||
              $route.name === 'brandOperatingSystem',
          }"
          @mouseover="openSideNav = true"
        >
          <a @click="allProjectsUrl"
            ><i
              ><icon-base
                :width="28"
                :height="28"
                :viewBox1="24"
                :viewBox2="24"
                iconName="projects"
                ><icon-projects /></icon-base></i
            ><span>All Projects</span></a
          >
        </li>
        <li
          id="headerLibraryLink"
          :class="{
            'is-active':
              $route.name === 'shelfLibrary' ||
              $route.name === 'shelfSearch' ||
              $route.name === 'shelfDetails',
          }"
          @mouseover="openSideNav = true"
          v-if="
            (dashboardDetailsInfo[0].ShelfLibraryEnabled &&
              !showShelfLibraryURL) ||
            account.navigation.some((nav) => nav.id === 24)
          "
        >
          <router-link to="/shelf-search" @click.native="openSideNav = false"
            ><i>
              <icon-base
                :width="40"
                :height="40"
                :viewBox1="24"
                :viewBox2="24"
                iconName="plan"
                ><icon-plan /></icon-base></i
            ><span>Project Planning Tool </span></router-link
          >
        </li>
        <li
          id="headerSupportLink"
          v-if="dashboardDetailsInfo[0].SupportEnabled"
          @mouseover="openSideNav = true"
        >
          <a @click="openHelpModal(true, 'support')"
            ><i
              ><icon-base
                :viewBox1="512"
                :viewBox2="512"
                :width="40"
                :height="40"
                iconName="support"
                iconColor="#fff"
                ><icon-support /></icon-base></i
            ><span>Support</span></a
          >
        </li>
        <li
          v-if="showMapMaker"
          @mouseover="openSideNav = true"
          :class="{
            'is-active': $route.name === 'map-maker',
          }"
        >
          <router-link to="/map-maker" @click.native="openSideNav = false"
            ><i>
              <icon-base
                :width="40"
                :height="40"
                :viewBox1="24"
                :viewBox2="24"
                iconName="mapMaker"
                iconStroke="#fff"
                iconColor="transparent"
                ><icon-map-maker /> </icon-base></i
            ><span>Map Maker </span></router-link
          >
        </li>
      </ul>
      <ul
        class="side-nav__list side-nav__list--bottom"
        v-if="$route.meta.hideNavigation !== true"
      >
        <li
          @mouseover="openSideNav = true"
          @click="sidePanel = !sidePanel"
          :class="{ 'is-active': sidePanel }"
        >
          <a
            ><i
              ><icon-base
                :width="40"
                :height="40"
                :viewBox1="24"
                :viewBox2="24"
                iconName="settings"
                ><icon-settings /></icon-base></i
            ><span>Settings</span>
            <font-awesome-icon class="ml-auto mr-15" icon="arrow-right"
          /></a>
        </li>
        <li @mouseover="openSideNav = true" @click="signOut">
          <a
            ><i
              ><icon-base
                :width="40"
                :height="40"
                :viewBox1="24"
                :viewBox2="24"
                iconName="signout"
                ><icon-signout /></icon-base></i
            ><span>Sign Out</span>
          </a>
        </li>
      </ul>

      <div
        class="side-nav__sub-list"
        v-if="sidePanel"
        @mouseleave="(sidePanel = false), (openClientList = false)"
      >
        <div class="side-nav__sub-list-inner">
          <div
            v-if="clients.length > 1 && showAccountDropdown"
            class="clientList input-group input-group--small"
          >
            <label> Account</label>
            <div
              class="clientList__active"
              :class="{ 'is-open': openClientList }"
            >
              <span @click="openClientList = !openClientList">{{
                activeClient.ClientName
              }}</span>
              <ul v-if="openClientList">
                <li
                  @click="onChangeClient(client.ClientId)"
                  v-for="client in clients"
                  :key="client.ClientId"
                  :class="{
                    'is-active': client.ClientId === activeClient.ClientId,
                  }"
                >
                  {{ client.ClientName }}
                </li>
              </ul>
            </div>
          </div>
          <p v-if="hsStaff && account.UserType !== 'Guest'" @click="gotoAdmin">
            <font-awesome-icon icon="toolbox" />Lab Admin
          </p>

          <p
            @click="updateProfile()"
            :class="{
              'is-disable': !allowEditProfile,
              'is-active': $route.name === 'update-profile',
            }"
            v-if="
              account.SkinIdentifier !== 'pg' && account.UserType !== 'Guest'
            "
          >
            <font-awesome-icon icon="id-card-alt" />Update Profile

            <span class="cta-info" v-if="!allowEditProfile">
              Hotspex user: Please contact Helpdesk to update your profile for
              the Awesome site
            </span>
          </p>

          <p
            @click="routerTrigger('/user-management')"
            v-if="showUserManagement"
            :class="{
              'is-active': $route.name === 'user-management',
            }"
          >
            <font-awesome-icon icon="user-edit" />User Management
          </p>
          <p
            @click="routerTrigger('/account-management')"
            v-if="showAccountManagement"
            :class="{
              'is-active': $route.name === 'account-management',
            }"
          >
            <font-awesome-icon icon="users" />Account Management
          </p>
          <p
            @click="routerTrigger('/client-management')"
            v-if="showClientManagement"
            :class="{
              'is-active': $route.name === 'client-management',
            }"
          >
            <font-awesome-icon icon="user-friends" />Client Management
          </p>
          <p
            @click="openHelpModal(true, 'faq')"
            :class="{
              'is-active': showHelpModal.open,
            }"
          >
            <font-awesome-icon icon="life-ring" />Need Help?
          </p>
          <p v-if="showErrorView" @click="showErrorLog">
            <font-awesome-icon icon="eye" />View error log
          </p>
        </div>
      </div>
    </div>

    <keep-alive>
      <router-view />
    </keep-alive>

    <div
      v-if="showHelpModal.open"
      ref="movableDiv"
      class="need-help-modal"
      @mousedown="startDrag"
    >
      <div class="need-help-modal__title flex items-center justify-between">
        <h2 class="flex items-center gap-5">
          Need Help?

          <a-tooltip overlayClassName="ant-tooltip--step-nav">
            <template slot="title">
              Move this modal to where it suits you best.
            </template>
            <a-icon type="info-circle" class="cursor-pointer" />
          </a-tooltip>
        </h2>
        <div @click="openHelpModal(false, '')" class="cursor-pointer flex">
          <icon-base
            :width="18"
            :height="18"
            :viewBox1="1024"
            :viewBox2="1024"
            iconName="close"
            iconColor="#000"
            iconStroke="transparent"
            ><icon-close
          /></icon-base>
        </div>
      </div>
      <div class="need-help-modal__content">
        <div class="need-help">
          <ul class="need-help__tabs flex">
            <li
              :class="{ 'is-active': showHelpModal.tabName === 'faq' }"
              @click="openHelpModal(true, 'faq')"
            >
              FAQ
            </li>
            <li
              :class="{ 'is-active': showHelpModal.tabName === 'support' }"
              @click="openHelpModal(true, 'support')"
            >
              Tutorials
            </li>
            <li
              :class="{ 'is-active': showHelpModal.tabName === 'pythia' }"
              @click="openHelpModal(true, 'pythia')"
              v-if="account.tools.some((tool) => tool.id === 8)"
            >
              CharlesBot
            </li>
          </ul>

          <div class="need-help__content">
            <div
              v-html="faqContent"
              v-show="showHelpModal.tabName === 'faq'"
            ></div>
            <div
              v-show="showHelpModal.tabName === 'support'"
              class="need-help__support"
            >
              <h2>1. How do I add a shelf to the platform?</h2>
              <iframe
                src="https://scribehow.com/embed-preview/Adding_a_Shelf_to_Platform__RC8hZ_iaTvCyQyqUa0xL4A"
                width="100%"
                height="640"
                allowfullscreen
                frameborder="0"
                class="mb-25"
              ></iframe>

              <h2>2. How do I set up a Pack Test in the platform?</h2>
              <iframe
                src="https://scribehow.com/embed-preview/Configure_a_Pack_Test_Project__OddWtrHjRh-sztlctjfJEw"
                width="100%"
                height="640"
                allowfullscreen
                frameborder="0"
              ></iframe>
            </div>
            <div v-show="showHelpModal.tabName === 'pythia'">
              <div v-if="false">
                <p>
                  Meet CharlesBot, your go-to assistant for all technical
                  details and frequently asked questions about our company.
                  Whether you need product information, troubleshooting advice,
                  or insights on our services, just ask away! Available 24/7 to
                  provide accurate and detailed answers, making your experience
                  smoother and more efficient.
                </p>
                <a-button type="primary" @click="openChatBot" class="mt-5"
                  >Discuss now!</a-button
                >
              </div>

              <ChatBot />
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      :title="errorLogModalTitle"
      :visible="showErrorLogModal"
      @cancel="showErrorLogModal = false"
      class="ant-modal--error-log"
      :afterClose="onCloseErrorLogModal"
    >
      <div
        v-if="showErrorLogLoading"
        class="flex justify-center error-log-loader"
      >
        <i class="circle-loader"></i> Loading data...
      </div>
      <div v-else class="error-log">
        <div
          class="error-log__item"
          v-for="(item, index) in errorsLogList"
          :key="index"
        >
          <h3>Error date</h3>
          <p>
            {{ item.ErrorDate !== "" ? item.ErrorDate : "/" }}
          </p>
          <h3>User</h3>
          <p>
            {{ item.User !== "" ? item.User : "/" }}
          </p>
          <h3>Survey</h3>
          <p>
            {{ item.surveyName !== "" ? item.surveyName : "/" }}
          </p>
          <h3>Error message</h3>
          <p>
            {{ item.ErrorMessage !== "" ? item.ErrorMessage : "/" }}
          </p>
          <h3>Error stack trace</h3>
          <p>
            {{ item.ErrorStackTrace !== "" ? item.ErrorStackTrace : "/" }}
          </p>
          <h3>Error inner exception</h3>
          <p>
            {{
              item.ErrorInnerException !== "" ? item.ErrorInnerException : "/"
            }}
          </p>
          <h3>Error source</h3>
          <p>
            {{ item.ErrorSource !== "" ? item.ErrorSource : "/" }}
          </p>
        </div>
        <div class="mt-25 flex justify-end">
          <a-pagination
            v-model="errorLogCurrentPage"
            :total="errorLogTotal"
            @change="getErrorLogs"
          />
        </div>
      </div>
      <template #footer>
        <a-button key="back" type="primary" @click="showErrorLogModal = false"
          >Cancel</a-button
        >
      </template>
    </a-modal>

    <a-modal
      title="You've been gone a while"
      :visible="sessionTimeoutModal"
      @cancel="sessionModalClose"
      :footer="null"
      :width="350"
      :afterClose="sessionModalClose"
      class="ant-modal--session"
    >
      <p>For your security, this page is expiring. Select "Ok" to continue.</p>
      <div>
        <a-button type="primary" @click="sessionModalClose">Ok</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as jsUtils from "@/utils/jsUtils.js";
import * as wsUtils from "@/utils/wsUtils.js";
import { bus } from "@/main.js";
import IconBase from "@/components/general/IconBase.vue";
import IconHome from "@/components/icons/IconHome.vue";
import IconPlan from "@/components/icons/IconPlan.vue";
import IconSupport from "@/components/icons/IconSupport.vue";
import IconProjects from "@/components/icons/IconProjects.vue";
import IconSettings from "@/components/icons/IconSettings.vue";
import IconSignout from "@/components/icons/IconSignout.vue";
import IconMapMaker from "@/components/icons/IconMapMaker.vue";
import { store } from "@/utils/store.js";
import IconClose from "@/components/icons/IconClose.vue";
import { mutations } from "@/utils/store.js";
import ChatBot from "@/components/general/ChatBot.vue";

export default {
  components: {
    IconBase,
    IconHome,
    IconPlan,
    IconSupport,
    IconProjects,
    IconSettings,
    IconSignout,
    IconMapMaker,
    IconClose,
    ChatBot,
  },
  data() {
    return {
      account: {},
      clients: [],
      showProfile: false,
      sidePanel: false,
      selectClient: "",
      clientName: "",
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      hsStaff: false,
      helpModal: false,
      allowEditProfile: true,
      dashboardDetailsInfo: [
        {
          AuthoringEnabled: false,
          ShelfLibraryEnabled: false,
          SupportEnabled: false,
          SupportText: "",
        },
      ],
      loadingDashboardDetails: true,
      user: null,
      faqContent: null,
      helpModalActiveContent: "",
      needHelpLoading: false,
      showErrorLogLoading: false,
      showErrorLogModal: false,
      errorsLogList: [],
      errorLogCurrentPage: 1,
      errorLogTotal: 0,
      sessionTimeoutModal: false,
      openSideNav: false,
      openClientList: false,
      isDragging: false,
      offset: { x: 0, y: 0 },
    };
  },
  onIdle() {
    if (this.$route.meta.requireAuth) {
      jsUtils.setDashboardURL(this.account.dashboardURL);
      this.sessionTimeoutModal = true;
      this.signOut();
    }
  },
  methods: {
    startDrag(event) {
      const classesToIgnore = [
        "chatbot__messages-container",
        "chatbot__input-container",
        "chatbot__input",
      ];

      if (classesToIgnore.some((cls) => event.target.classList.contains(cls))) {
        return;
      }
      this.isDragging = true;
      this.offset.x = event.clientX - this.$refs.movableDiv.offsetLeft;
      this.offset.y = event.clientY - this.$refs.movableDiv.offsetTop;
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDrag(event) {
      if (this.isDragging) {
        const div = this.$refs.movableDiv;
        div.style.left = `${event.clientX - this.offset.x}px`;
        div.style.top = `${event.clientY - this.offset.y}px`;
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    onChangeClient(clientId) {
      this.selectClient = clientId;
      localStorage.setItem("clientID", this.selectClient);
      this.sidePanel = false;
      location.reload();
    },
    signOut() {
      this.openSideNav = false;
      let SAMLSSOUser = jsUtils.readCookie("SAMLSSOSignedIn");
      if (SAMLSSOUser) {
        this.singOutSAMLSSOUser();
      } else {
        this.singOutRegularUser();
      }
    },
    sessionModalClose() {
      let dashboarURL = jsUtils.getDashboardURL();
      if (dashboarURL === undefined) {
        this.sessionTimeoutModal = false;
      } else {
        window.open(dashboarURL, "_self", "noreferrer");
      }
    },
    singOutRegularUser() {
      this.sidePanel = false;
      this.showProfile = false;
      document.body.classList.remove("login");
      jsUtils.clearSetting();
      this.account = {};
      jsUtils.deleteCookie("SSOSignedIn");
      jsUtils.deleteCookie("survey-type");
      this.$router.push("/login");
    },
    singOutSAMLSSOUser() {
      jsUtils.deleteCookie("survey-type");
      jsUtils.deleteCookie("SAMLSSOSignedIn");
      jsUtils.deleteCookie("HS-STUDIO");
      this.$router.push("/samlssos-singout");
      this.sidePanel = false;
      this.showProfile = false;
      document.body.classList.remove("login");
      // jsUtils.clearSetting();
      this.account = {};
    },
    gotoAdmin() {
      let adminUrl;
      if (
        window.location.hostname === "app.hotspexlabs.com" ||
        window.location.hostname === "pg.hotspexlabs.com"
      ) {
        adminUrl = "https://admin.hotspexlabs.com/";
      } else if (window.location.hostname === "app-uat.hotspexstudio.com") {
        adminUrl = "https://admin-uat.hotspexstudio.com";
      } else {
        adminUrl = "https://staging-admin.hotspexstudio.com";
      }
      window.open(adminUrl, "_blank");
    },
    getAccountInfo() {
      let account = jsUtils.readCookie("HS-STUDIO");

      if (account) {
        this.account =
          JSON.parse(localStorage.getItem("studioUser")) ||
          JSON.parse(jsUtils.readCookie("HS-STUDIO"));

        let clientID = localStorage.getItem("clientID");

        this.clients = this.account.Clients;

        this.showProfile = true;
        this.hsStaff = this.account.EmailId.indexOf("hotspex.com") !== -1;

        if (clientID === undefined || clientID === null) {
          // if no selected client ID, we will pick the first item from client lists
          this.clientName = this.clients[0].ClientName;
          this.selectClient = this.clients[0].ClientId;
        } else {
          // there is selected client in cookie, we will find that client in our list
          this.selectClient = parseInt(clientID, 10);
          this.clientName = this.clients.find((client) => {
            return parseInt(client.ClientId, 10) === this.selectClient;
          })?.ClientName;
        }

        if (this.account.EmailId.includes("hotspex.com")) {
          this.allowEditProfile = false;
        } else {
          this.allowEditProfile = true;
        }
      } else {
        this.showProfile = false;
      }
    },
    goHome() {
      this.$router.push("/");
      this.sidePanel = false;
    },
    allProjectsUrl() {
      this.user =
        JSON.parse(localStorage.getItem("studioUser")) ||
        JSON.parse(jsUtils.readCookie("HS-STUDIO"));
      if (
        this.user.dashboardURL !== "" &&
        this.user.dashboardURL !== undefined
      ) {
        window.open(this.user.dashboardURL, "_self", "noreferrer");
      } else {
        this.openSideNav = false;
        this.$router.push({ path: "/all-projects" });
      }
    },
    updateProfile() {
      if (this.allowEditProfile) {
        this.$router.push("update-profile");
        this.sidePanel = false;
      }
    },
    routerTrigger(route) {
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
      this.sidePanel = false;
      this.openSideNav = false;
    },
    setSkin() {
      try {
        let userInfo =
          JSON.parse(localStorage.getItem("studioUser")) ||
          JSON.parse(jsUtils.readCookie("HS-STUDIO"));
        let skinClass = userInfo.SkinIdentifier.toLowerCase();
        if (skinClass !== "") {
          document.body.classList.add(skinClass, "login");
        }
      } catch {
        return null;
      }
    },
    dashboardDetails() {
      const getDashboardDetails = new Promise((resolve) => {
        wsUtils.GetDashboardDetails(
          {
            userid: this.account.EncrypteduserID,
          },
          resolve
        );
      });

      getDashboardDetails.then((data) => {
        if (data.length !== 0) {
          this.dashboardDetailsInfo = data;
        }
        this.loadingDashboardDetails = false;
      });
    },
    showErrorLog() {
      this.sidePanel = false;
      this.showErrorLogLoading = true;
      this.showErrorLogModal = true;
      this.getErrorLogs();
    },
    getAccountFAQ() {
      const getAccountFAQContent = new Promise((resolve) => {
        wsUtils.GetAccountFAQContent(
          {
            accountId: this.account.AccountId,
          },
          resolve
        );
      });

      getAccountFAQContent.then((data) => {
        this.faqContent = data.FAQcontent;
      });
    },
    getErrorLogs() {
      const getGeneralErrorLog = new Promise((resolve) => {
        wsUtils.GetGeneralErrorLog(
          {
            count: this.errorLogCurrentPage.toString(),
            pageSize: "5",
          },
          resolve
        );
      });

      getGeneralErrorLog.then((data) => {
        this.errorsLogList = data.ErrorLOgs;
        this.errorLogTotal = data.TotalRecords;
        this.showErrorLogLoading = false;
      });
    },
    onCloseErrorLogModal() {
      this.activeSurveyName = null;
      this.errorsLogList = [];
      this.errorLogCurrentPage = 1;
    },
    openHelpModal(open, tabName) {
      this.openSideNav = false;
      this.sidePanel = false;
      mutations.openHelpModal(open, tabName);
    },
    openChatBot() {
      window.open(
        "https://hotspex-support.azurewebsites.net/",
        "_blank",
        "noreferrer"
      );
    },
  },
  computed: {
    showShelfLibraryURL() {
      return this.$route.path.includes("/comms-test/");
    },
    showTopBarNav() {
      return (
        this.$route.meta.hideNavigation !== true &&
        (this.account.AccountType === "Agency" ||
          this.account.AccountType === "Enterprise" ||
          this.account.AccountType === "Master/Hotspex" ||
          this.account.AccountType === "Basic") &&
        !this.loadingDashboardDetails &&
        this.account.UserType !== "Guest"
      );
    },
    clientsSelectDropdown() {
      return !this.sidePanel ? "display-none" : "";
    },
    showUserManagement() {
      return (
        (this.account.planID === 2 ||
          this.account.planID === 3 ||
          this.account.planID === 4) &&
        this.account.UserType === "Admin" &&
        this.account.UserType !== "Guest"
      );
    },
    showAccountManagement() {
      //1 Basic, 2 Enterprise, 3 Agency
      return (
        (this.account.planID === 2 || this.account.planID === 3) &&
        this.account.UserType === "Admin" &&
        this.account.UserType !== "Guest"
      );
    },
    showAccountDropdown() {
      //1 Basic, 2 Enterprise, 3 Agency
      return (
        this.account.planID === 3 ||
        (this.account.planID === 4 && this.account.UserType !== "Guest")
      );
    },
    showClientManagement() {
      //1 Basic, 2 Enterprise, 3 Agency
      return this.account.planID === 3 && this.account.UserType !== "Guest";
    },
    showErrorView() {
      //1 Basic, 2 Enterprise, 3 Agency 4 Master
      return this.account.planID === 4 && this.account.UserType !== "Guest";
    },
    errorLogModalTitle() {
      return (
        "Error log " +
        (this.errorLogTotal !== 0
          ? "- Number of logs: " + this.errorLogTotal
          : "")
      );
    },
    activeClient() {
      return this.clients.find((item) => item.ClientId === this.selectClient);
    },
    getNavClosed() {
      return store.navClosed;
    },
    showMapMaker() {
      return (
        this.account.AccountType === "Master/Hotspex" ||
        this.account.navigation.some((nav) => nav.id === 25)
      );
    },
    showHelpModal() {
      return store.helpModal;
    },
  },
  created() {
    this.setSkin();
  },
  mounted() {
    this.getAccountInfo();
    this.getAccountFAQ();
    this.$router.onReady(() => {
      if (
        this.$route.meta.hideNavigation !== null &&
        this.$route.meta.hideNavigation !== true
      ) {
        this.dashboardDetails();
      }
    });

    bus.$on("login", () => {
      this.getAccountInfo();
      this.dashboardDetails();
      this.getAccountFAQ();
    });
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-left: 96px;
  height: 100%;

  .logoSection {
    cursor: pointer;
  }
  &.overflow-auto {
    overflow: auto;
  }
  &.dark-bcg {
    background: #212121;
  }
}

.need-help-modal {
  width: 750px;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: move;
  z-index: 998;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.1);
  &__title {
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;
    h2 {
      margin: 0;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
  }
  &__content {
    padding: 20px;
  }
}

.need-help {
  border-top: 0;
  h2 {
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 600;
  }
  &__tabs {
    padding: 0;
    background: #fff;
    margin: 0;
    li {
      padding: 10px;
      border: 1px solid #e5e5e5;
      text-align: center;
      cursor: pointer;
      min-width: 100px;
      font-weight: 400;
      margin: 0 -1px -1px 0;
      background: #f7f7f7;
      &.is-active {
        border-bottom-color: #fff;
        font-weight: 500;
        background: #fff;
      }
      &:first-child {
        border-top-left-radius: 8px;
      }
      &:last-child {
        border-top-right-radius: 8px;
      }
    }
  }
  &__content {
    padding: 20px;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    border-top-left-radius: 0;
    max-height: 660px;
    overflow: auto;
    min-height: 420px;
  }
  &__faq {
    padding: 0;
    margin-bottom: 45px;
    li:not(:last-child) {
      border-bottom: 1px solid #ececec;
      margin-bottom: 12px;
    }
  }
  &__contact {
    ul {
      padding: 0;
      li {
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        &:last-child {
          margin-bottom: 0;
        }
        svg {
          margin-right: 11px;
          color: var(--hsblue);
        }
      }
    }
  }
  &__support {
    a {
      display: table;
      color: var(--hsblue);

      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' xml:space='preserve'%3E%3Cpath d='M58.003 8H5.997a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h52.006a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6zm4 41.11L43.085 30.193l18.918-12.056v30.975zM5.997 10h52.006c2.206 0 4 1.794 4 4v1.766L34.468 33.313c-1.49.95-3.394.92-4.85-.07L1.997 14.47V14c0-2.206 1.794-4 4-4zm-4 6.885 19.185 13.04L1.997 49.111V16.885zM58.003 54H5.997a4.005 4.005 0 0 1-3.677-2.428l20.52-20.52 5.655 3.844a6.41 6.41 0 0 0 7.046.104l5.842-3.724L61.68 51.572A4.005 4.005 0 0 1 58.003 54z'/%3E%3C/svg%3E")
        no-repeat 0 center;
      background-size: 16px;
      padding-left: 21px;
      margin-bottom: 4px;
    }
    p {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    ul {
      margin: 0;
      padding: 0;
      li {
        margin-bottom: 24px;
        font-size: 14px;
        position: relative;
        &:after {
          position: absolute;
          left: 0;
          bottom: -12px;
          content: "";
          width: 40px;
          border-bottom: 1px solid lightgrey;
        }
        &:last-child {
          margin-bottom: 0;
          &::after {
            display: none;
          }
        }
        strong {
          font-weight: 500;
          margin-bottom: 4px;
          display: block;
        }
        p {
          background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60.002 60.002' style='enable-background:new 0 0 60.002 60.002' xml:space='preserve'%3E%3Cpath d='M59.002 37.992a6.701 6.701 0 0 1-6.693-6.693 1 1 0 1 0-2 0c0 4.794 3.899 8.693 8.693 8.693a1 1 0 1 0 0-2z'/%3E%3Cpath d='M58.256 35.65a1 1 0 1 0 0-2c-.886 0-1.605-.72-1.605-1.605a1 1 0 1 0-2 0 3.608 3.608 0 0 0 3.605 3.605zM20.002 2.992a6.7 6.7 0 0 1 6.693 6.693 1 1 0 1 0 2 0c0-4.794-3.9-8.693-8.693-8.693a1 1 0 1 0 0 2z'/%3E%3Cpath d='M19.748 6.334a1 1 0 0 0 1 1c.885 0 1.604.72 1.604 1.605a1 1 0 1 0 2 0 3.609 3.609 0 0 0-3.604-3.605 1 1 0 0 0-1 1zM44.076 37.889c-1.276-.728-2.597-.958-3.721-.646-.844.234-1.532.768-1.996 1.546-1.02 1.22-2.286 2.646-2.592 2.867-2.367 1.604-4.25 1.415-6.294-.629L17.987 29.542c-2.045-2.045-2.233-3.928-.631-6.291.224-.31 1.65-1.575 2.87-2.596.778-.464 1.312-1.152 1.546-1.996.311-1.123.082-2.444-.652-3.731-.173-.296-4.291-7.27-8.085-9.277a4.909 4.909 0 0 0-5.796.872L4.7 9.059C.686 13.073-.767 17.622.379 22.579c.956 4.132 3.742 8.529 8.282 13.068l14.705 14.706c5.762 5.762 11.258 8.656 16.298 8.656 3.701 0 7.157-1.562 10.291-4.695l2.537-2.537a4.907 4.907 0 0 0 .872-5.796c-2.008-3.795-8.981-7.912-9.288-8.092zm7.002 12.474L48.541 52.9c-6.569 6.567-14.563 5.235-23.76-3.961L10.075 34.233c-4.271-4.271-6.877-8.344-7.747-12.104-.995-4.301.244-8.112 3.786-11.655l2.537-2.537a2.925 2.925 0 0 1 3.446-.518c3.293 1.743 7.256 8.454 7.29 8.511.449.787.62 1.608.457 2.196-.1.36-.324.634-.684.836l-.15.104c-.853.712-2.883 2.434-3.308 3.061-.612.904-1.018 1.792-1.231 2.665-.711-1.418-1.286-3.06-1.475-4.881a1.012 1.012 0 0 0-1.098-.892 1.002 1.002 0 0 0-.892 1.099c.722 6.953 6.129 11.479 6.359 11.668.025.02.054.028.08.045l10.613 10.613c.045.045.092.085.137.129.035.051.058.108.104.154.189.187 4.704 4.567 11.599 5.283a1.001 1.001 0 0 0 .206-1.99c-2.114-.219-3.987-.839-5.548-1.558.765-.23 1.543-.612 2.332-1.146.628-.426 2.35-2.455 3.061-3.308l.104-.151c.202-.359.476-.583.836-.684.588-.159 1.409.008 2.186.45.067.04 6.778 4.003 8.521 7.296a2.916 2.916 0 0 1-.518 3.444z'/%3E%3C/svg%3E")
            no-repeat 0 center;
          background-size: 16px;
          padding-left: 21px;
        }
      }
    }
  }
}

.side-nav {
  background: linear-gradient(180deg, #5f3ccc 13.09%, #ff4157 75.2%);
  width: 96px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  height: 100vh;
  padding: 43px 12px 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  &__close {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 37px;
    right: 12px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    transition: all 0.3s ease;
    opacity: 0;
    pointer-events: none;
    z-index: 1;
    cursor: pointer;
    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 19px;
      left: 10px;
      width: 50%;
      height: 2px;
      background-color: #fe114e;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
    &:hover {
      bacground: #fcfcfc;
    }
  }
  &.open {
    width: 280px;
    .side-nav__close {
      opacity: 1;
      pointer-events: all;
    }
    .side-nav__logo {
      width: 195px;
    }
    .side-nav__list {
      li {
        &.is-active {
          a {
            background: #3e4988;
          }
        }
        a {
          &:hover {
            background: #3e4988;
            i {
              background: transparent;
            }
          }
          span {
            opacity: 1;
            pointer-events: all;
          }
        }
      }
    }
  }
  &__logo {
    height: 30px;
    width: 80px;
    background: url("/images/logo-white2x.png") left center no-repeat;
    background-size: cover;
    margin-bottom: 70px;
    cursor: pointer;
    // .pg.login & {
    //   background: url("/images/client-logo/Procter_&_Gamble_logo.svg") center
    //     no-repeat;
    //   margin-top: 31px;
    //   width: 84px;
    //   height: 84px;
    //   @media screen and (max-width: 800px) {
    //   }
    // }

    // .demo.login & {
    //   background: url("/images/demo-logo.png") center no-repeat;
    //   width: 184px;
    //   height: 40px;
    //   background-size: contain;
    //   @media screen and (max-width: 800px) {
    //   }
    // }
  }
  &__list {
    margin: 0;
    padding: 0 4px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    &--bottom {
      margin-top: auto;
    }
    li {
      i {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 56px;
        border-radius: 20px;
        min-width: 64px;
        margin-right: 10px;
        font-size: 26px;
        transition: all 0.3s ease;
        > svg {
          stroke-width: 0;
        }
        > svg[aria-labelledby="projects"] path {
          stroke-width: 3px;
        }
      }
      &.is-active {
        i {
          background: #3e4988;
        }
      }
      a {
        display: flex;
        align-items: center;
        white-space: nowrap;
        color: #fff;
        font-weight: 500;
        border-radius: 20px;
        transition: 0.3s ease all;
        &:hover {
          i {
            background: #3e4988;
          }
        }
        span {
          opacity: 0;
          pointer-events: none;
          transition: 0.3s ease all;
        }
      }
    }
  }
  &__sub-list {
    left: 280px;
    bottom: 0;
    position: fixed;
    padding-bottom: 16px;
    text-align: left;
    padding-left: 16px;
  }
  &__sub-list-inner {
    padding: 20px 10px;
    background: linear-gradient(180deg, #5f3ccc 13.09%, #ff4157 75.2%), #fff;
    border-radius: 12px;
    label {
      color: #fff !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      margin-bottom: 3px !important;
    }
    p {
      cursor: pointer;
      transition: background-color 0.4s, color 0.4s;
      padding: 7px 10px;
      color: white;
      border-radius: 12px;
      font-size: 14px;
      margin: 0 0 7px;
      position: relative;
      svg {
        margin-right: 8px;
      }

      &.is-disable {
        cursor: default;
      }

      &:hover:not(.is-disable),
      &.is-active {
        background-color: #3e4988;
      }
      &:last-child {
        margin-bottom: 0;
      }
      &:hover {
        .cta-info {
          opacity: 1;
        }
      }
      .cta-info {
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
        position: absolute;
        bottom: calc(100% + 3px);
        background: #fff;
        padding: 6px 8px;

        color: var(--darkGrey);
        border-radius: 2px;
        box-shadow: 0 4px 12px #00000026;
        font-size: 12px;
        text-align: left;
        line-height: 15px;
        width: 163px;
        left: 0;
        &:after {
          position: absolute;
          right: 125px;
          transform: translate(-50%, 3px);
          bottom: -3px;
          content: "";
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid #fff;
          transition: all 0.2s ease;
        }
      }
    }
  }
}

.clientList {
  margin-bottom: 20px;
  padding: 0 11px;
  label {
    margin-bottom: 2px;
    display: block;
    svg {
      margin-right: 3px;
    }
  }
  &__active {
    position: relative;
    color: #fff;
    font-weight: 500;
    &.is-open {
      span {
        &:after {
          transform: rotate(-43deg);
          top: 9px;
        }
      }
    }
    span {
      cursor: pointer;
      position: relative;
      display: block;
      font-size: 14px;
      padding-right: 13px;
      &:after {
        position: absolute;
        right: 0;
        top: 4px;
        width: 8px;
        height: 8px;
        border-width: 1px 1px 0 0;
        border-style: solid;
        border-color: #fff;
        content: "";
        transform: rotate(135deg);
      }
    }
    ul {
      position: absolute;
      z-index: 10;
      padding: 9px 12px;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      gap: 6px;
      left: -1px;
      background: #fff;
      right: -1px;
      color: var(--darkText);
      border-radius: 9px;
      top: 25px;
      li {
        cursor: pointer;
        &:hover {
          color: var(--blueDark);
        }
        &.is-active {
          display: none;
        }
      }
    }
  }
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: all 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.clientOptions.ant-radio-group {
  margin-left: 0.8em;
}

.profile {
  cursor: pointer;
  transition: all 0.4s;

  svg {
    font-size: 1.4em;
  }
}

.display-none {
  display: none !important;
}

.custom-table {
  &--error-log-table {
    tbody {
      td {
        vertical-align: baseline;
        &:nth-child(3),
        &:nth-child(4) {
          max-width: 350px;
        }
      }
    }
  }
}

.error-log-loader {
  padding: 150px 0;
}

.error-log {
  &__item {
    padding: 24px;
    &:nth-child(odd) {
      background: #f7f7f7;
      border-radius: 10px;
    }
    h3 {
      font-size: 14px;
      margin-bottom: 2px;
    }
    p {
      font-size: 13px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.ant-modal {
  &--error-log {
    .ant-modal-wrap {
      padding: 20px;
    }
    .ant-modal {
      width: 100% !important;
      max-width: 1000px;
    }
  }
  &--session {
    .ant-modal-mask {
      background: #fff;
    }
  }
}
</style>
